<h1 mat-dialog-title>Solicitar Informação</h1>
<div mat-dialog-content>
  <p>Faça o seu cadastro e avisaremos quando a escola completar os dados na página</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="'Cancelar'">Cancelar</button>
  <button mat-button (click)="requestLogin()" cdkFocusInitial>Login</button>
</div>
